/* ghost-variant-guard.js — Lyvoi
   Kills dead clicks on (a) non-existent variant combos (e.g. Green/Mini, Rose gold/Mini)
   and (b) existing-but-sold-out combos, inside the quantity-break dropdowns.
   Data-driven: reads the live product JSON so it survives catalog changes.
   Pure progressive enhancement, no markup mutation, reversible.
*/
(function () {
  "use strict";
  var cache = {}; // handle -> {names:[], combos:Set, avail:{tuple:bool}}

  function handleFromPath() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function loadProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return null;
        var names = (p.options || []).map(function (o) { return typeof o === "string" ? o : o.name; });
        var combos = new Set();
        var avail = {};
        p.variants.forEach(function (v) {
          var k = v.options.join("");
          combos.add(k);
          avail[k] = !!v.available;
        });
        return (cache[handle] = { names: names, combos: combos, avail: avail });
      })
      .catch(function () { return null; });
  }

  // group selects (name="options[...]") into widgets by nearest shared ancestor
  function widgets() {
    var sels = Array.prototype.slice.call(
      document.querySelectorAll('select[name^="options["]')
    );
    var groups = [];
    sels.forEach(function (s) {
      var key = s.closest('.quantity-breaks-container, .quantity-break, form[action*="/cart/add"]') || document.body;
      var g = groups.find(function (x) { return x.key === key; });
      if (!g) { g = { key: key, selects: [] }; groups.push(g); }
      g.selects.push(s);
    });
    return groups;
  }

  function optName(sel) {
    var m = sel.name.match(/options\[(.+)\]/);
    return m ? m[1] : sel.name;
  }

  // selectable = combo exists AND variant is in stock (available !== false)
  function selectable(data, values) {
    var tuple = data.names.map(function (n) { return values[n]; });
    if (tuple.some(function (t) { return t == null; })) return true; // incomplete -> don't block
    var k = tuple.join("");
    return data.combos.has(k) && data.avail[k] !== false;
  }

  function refresh(data, group) {
    // 2026-10-22: snapping one select dispatches "change", which re-enters refresh; with low stock
    // (.com: 5 in-stock combos) two selects kept snapping each other -> infinite recursion, PDP froze.
    if (group.busy) return;
    group.busy = true;
    try { refreshOnce(data, group); } finally { group.busy = false; }
  }

  function refreshOnce(data, group) {
    var byName = {};
    group.selects.forEach(function (s) { byName[optName(s)] = s; });
    var current = {};
    Object.keys(byName).forEach(function (n) { current[n] = byName[n].value; });

    group.selects.forEach(function (sel) {
      var name = optName(sel);
      Object.keys(byName).forEach(function (n) { current[n] = byName[n].value; }); // re-read after a snap
      Array.prototype.forEach.call(sel.options, function (opt) {
        var trial = Object.assign({}, current);
        trial[name] = opt.value;
        opt.disabled = !selectable(data, trial);
      });
      // if the selected option got disabled, snap to first enabled
      if (sel.selectedOptions[0] && sel.selectedOptions[0].disabled) {
        var ok = Array.prototype.find.call(sel.options, function (o) { return !o.disabled; });
        if (ok) { sel.value = ok.value; sel.dispatchEvent(new Event("change", { bubbles: true })); }
      }
    });
  }

  function wire() {
    var handle = handleFromPath();
    if (!handle) return;
    loadProduct(handle).then(function (data) {
      if (!data || data.names.length < 2) return; // single-option products can't have ghost combos
      widgets().forEach(function (group) {
        if (group.selects.length !== data.names.length) return; // single-case only; Duo/Triple app-managed (byName collision)
        // flag lives on the select: groups are rebuilt on every wire(), so a group flag re-added listeners each time
        if (group.selects.every(function (s) { return s._gvg; })) return;
        group.selects.forEach(function (s) { s._gvg = true; });
        group.selects.forEach(function (s) {
          s.addEventListener("change", function () { refresh(data, group); });
        });
        refresh(data, group);
      });
    });
  }

  function init() {
    wire();
    // app renders quantity-break rows async — re-wire on DOM mutations (debounced)
    var t;
    var mo = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(wire, 200);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
